import React from 'react';
import './FacebookVideo.scss';

export default function FacebookVideo(props) {
  const file = props.file;
  const iframe = React.createRef();

  return <div className="facebook-responsive" ref={iframe}>
    <div className="fb-video"
         data-href={file.get('remote_file')}
         data-width="500"
         data-allowfullscreen="true"
         data-autoplay="true"
         data-show-captions="true"></div>
  </div>;
}
